const updateUrlWithoutReload = (url)=>{
    if (window.history) {
        window.history.replaceState({
            path: url
        }, window.document.title, url);
    }
};

export { updateUrlWithoutReload };
//# sourceMappingURL=update-url.js.map
